export const MotionEffectsInitSymbol = Symbol('MotionEffects')
export const MotionEffectsInitCallbackSymbol = Symbol('MotionEffectsCallback')
export const MotionEffectsAPISymbol = Symbol('MotionEffectsAPI')

export const name = 'motionEffects' as const

export const MOTION_EFFECTS_CALLBACK = 'motionEffectsCallback'
